import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEventsScope } from '../contexts/EventsScopeContext';

export const useFinalizePartnerEventAttendanceMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { api, queryKeys } = useEventsScope();
  const finalizeAttendance = api.finalizeAttendance;
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ eventId, payload }) => {
      if (!finalizeAttendance) {
        throw new Error('Finalize attendance is not available for this account');
      }
      if (!eventId) {
        throw new Error('Event id is required to finalize attendance');
      }

      const result = await finalizeAttendance(eventId, payload);
      if (!result.success) {
        throw new Error(result.message || 'Failed to finalize attendance');
      }
      return result.data;
    },
    onSuccess: async (data, variables, context) => {
      const { eventId } = variables ?? {};
      await queryClient.invalidateQueries({ queryKey: queryKeys.all });
      if (eventId) {
        await queryClient.refetchQueries({
          queryKey: queryKeys.detail(eventId),
          type: 'active',
        });
      }
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
